import type { Step } from "react-joyride";

export const formDetailTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າລາຍລະອຽດຟອມ! ທ່ານຈະໄດ້ເບິ່ງຂໍ້ມູນຄົບຖ້ວນຂອງຟອມ, ຊ່ອງຂໍ້ມູນ, ແລະປະຫວັດເວີຊັນ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="detail-header"]',
    content:
      "ນີ້ແມ່ນສ່ວນຫົວຂໍ້ຂອງຟອມ. ທ່ານສາມາດເບິ່ງຊື່ຟອມ, ສະຖານະ, ແລະປຸ່ມການກະທຳເຊັ່ນ ວິເຄາະ ແລະ ແກ້ໄຂ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="detail-instructions"]',
    content:
      "ນີ້ແມ່ນພາກຄຳແນະນຳແລະຈຸດປະສົງຂອງຟອມ. ທ່ານສາມາດເບິ່ງຂໍ້ມູນກ່ຽວກັບການນຳໃຊ້ຟອມ, ກຸ່ມເປົ້າໝາຍ, ແລະຂະບວນການຫຼັງຈາກສົ່ງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="detail-fields"]',
    content:
      "ນີ້ແມ່ນພາກສະແດງຊ່ອງຂໍ້ມູນຂອງຟອມ. ທ່ານສາມາດເບິ່ງຊ່ອງຂໍ້ມູນທັງໝົດທີ່ຖືກກຳນົດໃນຟອມ, ປະເພດ, ແລະຄຸນສົມບັດຂອງແຕ່ລະຊ່ອງ.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-stats"]',
    content:
      "ນີ້ແມ່ນພາກສະຖິຕິສຳລັບ. ທ່ານສາມາດເບິ່ງຈຳນວນການນຳໃຊ້, ການເປີດເບິ່ງ, ແລະຂໍ້ມູນອື່ນໆ ກ່ຽວກັບຟອມ.",
    placement: "left",
  },
  {
    target: '[data-tourid="detail-metadata"]',
    content:
      "ນີ້ແມ່ນພາກຂໍ້ມູນພື້ນຖານ. ທ່ານສາມາດເບິ່ງຜູ້ສ້າງ, ວັນທີສ້າງ, ວັນທີອັບເດດລ່າສຸດ, ແລະເວີຊັນປັດຈຸບັນ.",
    placement: "left",
  },
  {
    target: '[data-tourid="detail-versions"]',
    content:
      "ນີ້ແມ່ນພາກປະຫວັດເວີຊັນ. ທ່ານສາມາດເບິ່ງເວີຊັນທັງໝົດຂອງຟອມ, ການປ່ຽນແປງ, ແລະວັນທີສ້າງແຕ່ລະເວີຊັນ.",
    placement: "top",
  },
];
